export const GET_PUBLIC_COMPANIES = gql`
  query PublicCompanies {
    publicCompanies {
      companyId
      companyName
    }
  }
`
